import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.find";
import "core-js/modules/es.array.map";
import "core-js/modules/es.function.name";

/*
 * Copyright (c) 2020 Wells Fargo. 45 Fremont Street, San Francisco, CA 94105 All rights reserved.
 *
 *This software is the confidential and proprietary information of Wells Fargo
 *bank. ('Confidential Information'). You shall not disclose such Confidential
 *Information and shall use it only in accordance with the terms of the license
 *agreement you entered into with WellsFargo.
 *
 *Author: Thomas Barry
*/
import React, { useContext } from 'react';
import { useDispatch } from 'react-redux';
import { getClasses } from '../../../../lib/style-utils/style-utils';
import Block from '../../../block/Block';
import AccessibleClick from '../../../accessible-click/AccessibleClick';
import NavigationContext from '../../../navigation-context/NavigationContext';
import CombinationLockIcon from '../../../icons/combination-lock/CombinationLockIcon';
import useBrand from '../../../hooks/use-brand';
import WFMastheadContext from '../context/WFMastheadContext';
import Search from '../search/Search';
import styles from './MenuBar.less';

var MenuBar = function MenuBar() {
  var dispatch = useDispatch();

  var _useContext = useContext(NavigationContext),
      getContainer = _useContext.getContainer,
      navigate = _useContext.navigate;

  var _useContext2 = useContext(WFMastheadContext),
      menuType = _useContext2.menuType,
      device = _useContext2.device;

  var brand = useBrand();
  var links = getContainer('MASTHEAD_NAV').sections.find(function (_ref) {
    var name = _ref.name;
    return 'MAIN' === name;
  }).links;

  var onClick = function onClick(link) {
    return function () {
      return navigate({
        dispatch: dispatch,
        link: link
      });
    };
  };

  var classNames = getClasses({
    styles: styles,
    classes: ['bar'],
    brand: brand
  });
  return device.isDesktop() && menuType === 'bar' ? /*#__PURE__*/React.createElement(Block, {
    layout: true,
    horizontal: true,
    center: true,
    className: classNames
  }, /*#__PURE__*/React.createElement(Block, {
    el: "ul",
    layout: true,
    center: true,
    horizontal: true
  }, links.filter(function (_ref2) {
    var label = _ref2.label;
    return label;
  }).map(function (link, index) {
    return /*#__PURE__*/React.createElement("li", {
      key: "".concat(link.label, "-").concat(index)
    }, /*#__PURE__*/React.createElement(AccessibleClick, null, /*#__PURE__*/React.createElement("a", {
      role: "link",
      tabIndex: "0",
      onAccessibleClick: onClick(link)
    }, link.navigationId === 'ENROLL' ? /*#__PURE__*/React.createElement(Block, {
      layout: true,
      horizontal: true,
      center: true
    }, /*#__PURE__*/React.createElement(CombinationLockIcon, {
      width: "14px",
      height: "20px"
    }), /*#__PURE__*/React.createElement(Block, {
      pl: "xs"
    }, link.label)) : link.label)));
  })), /*#__PURE__*/React.createElement(Search, null)) : null;
};

export default MenuBar;